/* eslint-disable */
'use strict';
const { toastErrorMessage, toastSuccessMessage, appendToastMessage } = require('./wishlistToast');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();

    const icon = button.find('.wishlist-icon');

    if (data.success) {
        if (button.hasClass('already-added-to-wishlist')) {
            icon.removeClass('fa-heart').addClass('fa-heart-o');
            button.removeClass('already-added-to-wishlist');
        } else {
            icon.removeClass('fa-heart-o').addClass('fa-heart');
            button.addClass('already-added-to-wishlist');
        }

        appendToastMessage(toastSuccessMessage(data.msg));
    } else {
        appendToastMessage(toastErrorMessage(data.msg));
    }
}


module.exports = {
    
    toBoolean: function(value) {
        if (typeof value === 'string') {
            if (value.toLowerCase() === 'false') return false;
            if (value.trim() === '') return false;
        }
        return Boolean(value);
    },
    addToWishlist: function () {
        var _this = this;
        $('.add-to-wish-list').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if(_this.toBoolean($('#isloggedIn').val())) {
                var button = $(this);
                window.gtmTagManager.gtmWishListData(button);
                var isRemove = button.hasClass('already-added-to-wishlist');
                var url = isRemove ? button.data('remove-href') : button.data('href');
                var pid = button.closest('.product-detail').find('.product-id').html();
                pid = pid || $('.product-detail').data('pid');
                var optionId = button.closest('.product-detail').find('.product-option').attr('data-option-id') || null;
                var optionVal = button.closest('.product-detail').find('.options-select option:selected').attr('data-value-id') || null;
                var wishlistError = button.data('wishlisterror');

                if (!url || !pid) {
                    return;
                }

                $.spinner().start();
                button.attr('disabled', true);

                $.ajax({
                    url: url,
                    type: isRemove ? 'get' : 'post',
                    dataType: 'json',
                    data: {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal
                    },
                    success: function (data) {
                        displayMessage(data, button);
                        button.attr('disabled', false);
                    },
                    error: function (err) {
                        $.spinner().stop();
                        appendToastMessage(toastErrorMessage(wishlistError));
                        button.attr('disabled', false);
                    }
                });
            } else {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                var pid = $(this).data('pid') || $(this).closest('.product').data('pid');
                if (pid) {
                    sessionStorage.setItem('guestWishlistItems', JSON.stringify(pid));
                }
                $('#wishlist-login-modal').modal('show');
            }
        });
    }
};
